/*
 * @Author: Roman
 * @Date: 2023-03-17 16:11:37
 * @LastEditors: romanyuen@qpp.com yuan719...
 * @LastEditTime: 2023-03-17 16:29:19
 * @FilePath: \qpmn-site\src\app\qp-ui-bootstrap\index.ts
 * @Description: 
 */
import angular from "angular";
import { module_name as beforeunloadModule } from "./beforeunload/beforeunload.module";
import { breadcrumbModule } from "./breadcrumb";
import { inputNumberModule } from "./input-number";
import { navDrawerModule } from "./nav-drawer";
import { qpTotopModule } from "./totop";
import { module_name as qpMsgDialog } from "@qpUIs/qp-message-dialog/qp-message-dialog.module";
import { module_name as qpMsgTooltip } from "@qpUIs/qp-message-tooltip/qp-message-tooltip.module";

let qpuiModule = angular.module("qpui.bootstrap", [breadcrumbModule.name, inputNumberModule.name, qpTotopModule.name, beforeunloadModule,navDrawerModule.name, qpMsgDialog, qpMsgTooltip]);

export { qpuiModule }